import { string, object } from "yup";

export default object().shape({
  agency_name: string()
    .nullable()
    .required("Please enter a agency name")
});
